(function() {
  // Fix sticky Add to Cart scroll position
  document.addEventListener('click', function(event) {
    const stickyButton = event.target.closest('[data-cart-bar-scroll]');

    if (!stickyButton) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const variantArea = document.querySelector('.radio__legend');

    if (!variantArea) return;

const offset = window.innerWidth <= 768 ? 380 : 150;
    const targetPosition =
      variantArea.getBoundingClientRect().top +
      window.pageYOffset -
      offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }, true);
})();